import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { useMetaPetitionItemList } from './hooks/useMetaPetitionItemList';

export const MetaPetitionItemList: React.FC = () => {
	const {
		data: { displayed, schemaJson },
	} = useMetaPetitionItemList();

	if (!displayed) {
		return null;
	}

	return (
		<Helmet>
			<script type="application/ld+json">{schemaJson}</script>
		</Helmet>
	);
};
